import { SET_ERROR, CLEAR_ERROR } from '../actions/actionTypes';

const initialState = {
  show: false,
  errorMessage: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR:
      return {
        ...state,
        ...{ show: true, errorMessage: action.errorMessage },
      };
    case CLEAR_ERROR:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
